//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DetailStrediskoSpisovychUzlu.ts						</Name>
//    <Description> Dialog detailu ginstre - St�edisko spisov�ch uzl�										</Description>
//    <Author>      JKLUSACEK													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-03-09                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.14.1
//AdtGeneratorConfig:[ T:(ginstre) GID:(Web.Det.Ts) V1:(ixs_tre,zkratka,nazev,poznamka,dat_od,dat_do,aktivita,dat_zmena,zmenu_prov,ixs_lpc,ixs_isu,spis_pl,spis_znak,spis_znak_spis,spis_znak_kopie,ixs_su_pod,ixs_fun_pod,spis_graf,spis_graf_v,ico,ixs_ext_ess) V2:() K1:() K2:() ]

namespace Gordic.Adm.WebControls {

	const { gcontent } = Decorators;

    /** inteface - Response slu�eb pro Detail */
    export interface IDetailStrediskoSpisovychUzluResponse {
        /** data v�stupu */
        data: Gordic.AdmIsl.Interface.GStrediskoSpisovychUzluReadDto,

        result: {
            /** data v�stupu */
            data: Gordic.AdmIsl.Interface.GStrediskoSpisovychUzluReadDto,
            /** chyby */
            errors: {
                /** zpr�va chyby */
                message: string
            }[],
            /** typ v�stupu operace */
            kind: Adm.Utils.GOperationResultKind
        }
    }

	//#endregion

	/** Dialog detailu  */
	@gcontent
    export class DetailStrediskoSpisovychUzlu extends GContentBase<DetailBase> {

		//#region attributes

        private gridRemoteControl: Gordic.Components.GridRC<any>;
        private gridCssClass: string;

            /** PK - ixs_tre */
            private ixs_tre: string | null;
        
        /** data detailu */
        private data: Gordic.AdmIsl.Interface.GStrediskoSpisovychUzluReadDto;
		/** p��znak p��m�ho p��stupu na detail */
		private detailCommand: boolean
		/** Tab pro xxxx */
		//private strediskaTab: GStrediskaTab;

		//#endregion

		//#endregion


        /** onContentReady */
        public onContentReady() {
            this.init();
        }
		//#region ready & init

        public closing() {
            return DetailBase.CloseAction(this);
        }

        /** refreshDetail content */
        private refreshDetail(): void {

            this.HideAllFlash(); 
			this.load();
		}

        /** Na�ten� dat ze serveru na n�sledn� nastaven� na detail okn� */
        private loadData() {

            this.HideAllFlash(); 

            var fragments: string[] = [Utils.GAdmIslConst.detail];

            if (this.newRecord) {
                fragments.push(Utils.GAdmIslConst.defaultValuesForNewRecord);
            }

            var readResult: any = this.isl.StrediskoSpisovychUzlu.read({
                data: { ixs_tre: this.ixs_tre },
                fragments: fragments
            } ).get();

            // SUCCESS
            readResult.done((output: IDetailStrediskoSpisovychUzluResponse) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.data = output.data;
                    this.sxsDetail = this.data.ixs_tre;

                    this.MetaData = this.data.MetaData || null;
                    this.Permissions = this.data.Permissions || null;
                    this.createForm();

                    this.element.findFields().gfield("model", "apply", this.data);
                    // this.strediskaTab.getTab().appendTo(this.element);
                    // this.strediskaTab.setDataTogrid(this.data.Strediska);
                    if (this.newRecord) {
                        this.SetEditMode(true);       // p�i NEW je okno ihned p�epnuto do edit re�imu - mus� b�t p�ed setMenuButtons()
                        //this.strediskaTab.updateStrediskaAction(true);
                    }

                    this.SetMenuButtons(this.editMode);
                    this.createSidebar();
                    //this.createGTab();
                } else {
                    var errors = output.result.errors;
                    for (var index = 0; index < errors.length; index++) {
                        var error = errors[index];
                        this.ShowLoadError(error.message, index);
                    }
                }
            });
            // ERROR
            readResult.fail((err) => {
                console.error("Chyba na�ten�! " + err );
                this.ShowLoadError("jres:32131045!");
            });   
        } // loadData

        private updateGrid( dto: Gordic.AdmIsl.Interface.GStrediskoSpisovychUzluReadDto ): any {
            return this.isl.StrediskoSpisovychUzlu.list({
              filters: { ixs_tre: dto.ixs_tre },
            }).getView()
        }

		//#endregion

        /** Ulo�en� dat formul��e do datab�ze */
        private saveData(nova_data: Gordic.AdmIsl.Interface.GStrediskoSpisovychUzluSaveDto): void {

            this.HideAllFlash(); 

            var upsertResult: any = this.isl.StrediskoSpisovychUzlu.upsert({ data: nova_data }).get();

            upsertResult.done((output: IDetailStrediskoSpisovychUzluResponse) => {

                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    Gordic.Data.readerCache.clearCache("Gordic.ControlsLogic.Client.GReaderGinstre");
                    this.refreshGrid(output.data, this.newRecord);
                    this.newRecord = false;
                    this.data = output.data; // prevezmu nova data vznikla ulozenim
                    this.sxsDetail = this.data.ixs_tre;
                    this.MetaData = this.data.MetaData || null;
                    this.Permissions = this.data.Permissions || null;
                    this.createForm();                // znovu vytvo��m� cel� form 
                    this.element.findFields().gfield("model", "apply", this.data);  // nasetov�n�� nov�ch dat do detailu
                    //this.strediskaTab.getTab().appendTo(this.element);
                    //this.strediskaTab.setDataTogrid(this.data.Strediska);

                    this.SetEditMode(false);
                    this.SetMenuButtons(false);
                    //this.strediskaTab.updateStrediskaAction(false);
                    this.ShowSaveSuccess();
                    this.createSidebar();
                }
                else {
                    var errors = output.result.errors;
                    for (var index = 0; index < errors.length; index++) {
                        var error = errors[index];
                        this.ShowSaveError(error.message, index);           // flash ne�sp�n�ho ulo�en�
                    }
                }

            });

            upsertResult.fail((err) => {
                console.error("Chyba ulo�en�! ");    
                this.ShowSaveError("jres:32000125!");   //RC 32000125 : Chyba ulo�en�
            });            
        }

        private refreshGrid(output: Gordic.AdmIsl.Interface.GStrediskoSpisovychUzluReadDto, newRecord: boolean) {
            var gridElement = this.gridRemoteControl as any;
            var grid = gridElement.gridInstance.element;
            if (grid.length != 0) {
                this.updateGrid(output).done((d: Gordic.Data.View) => {
                   var data = d.getDataRows(true, "data")[0];
                    var view: Gordic.Data.View = grid.ggrid("getView");
                   if (this.newRecord == true)
                      view.updateData(data, "add");
                   else
                      view.updateData(data, "update");
                   grid.ggrid("setData", view);
               });
            }
        }

		/** init content */
		private init() {

			DetailBase.DetailBaseInit(this);
			//this.strediskaTab = new GStrediskaTab();

			this.formElement = null;

			// lezu na detail ze seznamu a ne pomoc� linku
			if (this.detailCommand === false) {
				var GinListControlsObject = (Gin.DetailBuilderComponents as any).GinListControls.create(this);
				this.actions.addRange(GinListControlsObject.actions);
				this.createStatusBar(GinListControlsObject.statusBar);
				$.extend(this, GinListControlsObject.contentExtensions);
			}

			this.setTitle();
			this.createMenuBar();
			//this.createForm();
			this.loadData();            // to soucasne vytvori form podle nactenych dat; 
			this.createCommandBar();

            // lezu na detail ze seznamu a ne pomoc� linku
			if (this.detailCommand === false) {
				// vytvo�it �ipky na proch�zen� detailu
                (this as any).listControls_setup({
                    //gridRemoteControl: this.gridRemoteControl,
					//funkce, kter� ��dek z gridu p�etransformuje v dto pro zavol�n� this.load(dto); M��e vracet promise.
					rowToDto: function (gridState) {
						return {
                            ixs_tre: gridState.currentRow.data.ixs_tre,
						};
					},
					//template pro tooltip na �ipce n�sleduj�c�
                    nextItemTemplate: "jres:33000155",
					//template pro tooltip na �ipce p�edchoz�
                    prevItemTemplate: "jres:33000156"
				});
				(this as any).listControls_updateCaptions();
            }
		}

		/** vytvo�it statusbar */
		private createStatusBar(GinListControlsObject?: any) {
			const bar: MenuParams[] = [];
			if (GinListControlsObject !== undefined) {
				bar.push.apply(bar, GinListControlsObject);
			}
			this.statusBar(bar);
		}

		//#endregion

		//#region data

        /** Skryt� v�ech flash */
        private HideAllFlash() {
            // skryji p��padn� Flash panely - mus�m za��t s �ist�m �t�tem
            this.hideFlash("idSaveSuccess");    
            this.hideFlash("idSaveError");  
            this.hideFlash("idLoadError");
            for (var index = 0; index < 10; index++) {
                this.hideFlash("idSaveError" + index);
                this.hideFlash("idLoadError" + index);
            }
        }
        /** Zobraz� p��znaku �sp�n�ho ulo�en� */
        private ShowSaveSuccess() {
            this.showFlash("jres:32000123", "g-state-success", 2000, "idSaveSuccess"); //RC 32000123 : Detail byl �sp�n� ulo�en
        }
        /** Zobraz� p��znaku chyby p�i ulo�en� dat */
        private ShowSaveError(text: string, index?: number) {
            if (index === undefined)
                this.showFlash("jres:32000124: " + text, "g-state-error", 0, "idSaveError" ); //RC 32000124 : Chyba
            else
                this.showFlash("jres:32000124: " + text, "g-state-error", 0, "idSaveError" + index); //RC 32000124 : Chyba
        }
        /** Zobraz� p��znaku chyby p�i na�ten� dat */
        private ShowLoadError(text: string, index?: number) {
            if (index === undefined)
                this.showFlash("jres:32000124: " + text, "g-state-error", 0, "idLoadError"); //RC 32000124 : Chyba
            else
                this.showFlash("jres:32000124: " + text, "g-state-error", 0, "idLoadError" + index); //RC 32000124 : Chyba
        }

        

		//#region title

		/** nastavit titulek dialogu */
		private setTitle() {

            var title = "";

            if (this.newRecord === false) {
                title = "jres:32131033"  	//RC 32131033 : Detail
            }
            else {
                title = "jres:32000121" //RC 32000121 : Nov� z�znam
            }

            this.title = title;

		}


		//#endregion

		//#region form

		/** vytvo�it formul�� a na�ten� dat ze serveru */
        private createForm() {
            var nemenne = "jres:32131150"; //RC 32131150 : Nem�nn�
            this.MakeForm("FormStrediskoSpisovychUzluService");
            this.MakeSection("jres:29802703"); //RC 29802703 :  St�edisko spisov�ch uzl�
            this.MakeField("ico");
            this.MakeField("ixs_tre" );
            this.MakeField("zkratka" );
            this.MakeField("nazev" );
            this.MakeField("poznamka");
            this.MakeSelectField("ixs_isu", Gordic.Prefabs.Select.ginsesu(), {
                model: "model.ixs_isu=value.ixs_esu",
                serverFilters: { priz_int: 10 }
            });
            this.MakeBoolField("no_ssl_cfg_cen", {
                change: (ev, changeObj) => {
                    if (changeObj.value == true) {
                        this.ShowField("spis_pl");
                        this.ShowField("spis_znak");
                        this.ShowField("spis_znak_spis");
                        this.ShowField("spis_znak_kopie");
                        this.ShowField("ixs_fun_pod");
                    } else {
                        this.HideField("spis_pl");
                        this.HideField("spis_znak");
                        this.HideField("spis_znak_spis");
                        this.HideField("spis_znak_kopie");
                        this.HideField("ixs_fun_pod");
                    }
                }
            });
            this.MakeSelectField("spis_pl", Gordic.Prefabs.Select.sslsspl(), {
                model: "model.spis_pl=value.spis_pl"
            });
            this.MakeSelectField("spis_znak", Gordic.Prefabs.Select.sslsspz(), {
                model: "model.spis_pl=>value.spis_pl, model.spis_znak=value.spis_znak",
                serverFilters: {
                    spis_pl: new Gordic.Forms.Dependency("spis_pl", "spis_pl", true, false, this.element),
                    aktivita: null
                },
            });
            this.MakeSelectField("spis_znak_spis", Gordic.Prefabs.Select.sslsspz(), {
                model: "model.spis_pl=>value.spis_pl, model.spis_znak_spis=value.spis_znak",
                serverFilters: {
                    spis_pl: new Gordic.Forms.Dependency("spis_pl", "spis_pl", true, false, this.element),
                    aktivita: null
                },
            });
            this.MakeSelectField("spis_znak_kopie", Gordic.Prefabs.Select.sslsspz(), {
                model: "model.spis_pl=>value.spis_pl, model.spis_znak_kopie=value.spis_znak",
                serverFilters: {
                    spis_pl: new Gordic.Forms.Dependency("spis_pl", "spis_pl", true, false, this.element),
                    aktivita: null
                },
            });
            this.MakeSelectField("ixs_fun_pod", Gordic.Prefabs.Select.ginsfun(), {
                model: "model.ixs_fun_pod=value.ixs_fun",
            });
            this.MakeSelectField("ixs_ext_ess", Gordic.Prefabs.Select.intsext(), {
                model: "model.ixs_ext_ess=value.ixs_ext",
            })
            this.MakeSelectField("spis_graf", Gordic.Prefabs.Select.wflsgra(), {
                model: "model.spis_graf=value.spis_graf"
            });
            this.MakeSelectField("spis_graf_v", Gordic.Prefabs.Select.wflsgra(), {
                model: "model.spis_graf_v=value.spis_graf"
            });
            this.MakeField("dat_od" );
            this.MakeField("dat_do" );
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
            this.MakeField("dat_zmena"); 
          
          //this.MakeField("ixs_lpc" );
          //this.MakeField("ixs_su_pod" );
         

            var form = this.FinishMakeForm();
            if (this.data.no_ssl_cfg_cen == 0) {
                this.HideField("spis_pl");
                this.HideField("spis_znak");
                this.HideField("spis_znak_spis");
                this.HideField("spis_znak_kopie");
                this.HideField("ixs_fun_pod");
            }
		}

		//#endregion

		//#region menubar

		private nextAndPreviousAction(next: boolean) {
		    var obj: any;
		    if (next == true)
		        obj = this.gridRemoteControl.current().nextRow.data;
		    else
		        obj = this.gridRemoteControl.current().prevRow.data;
		    this.gridRemoteControl.move(next);
		    var gridElement = this.gridRemoteControl as any;
		    Dialogs.DetailStrediskoSpisovychUzluDlg($.content(gridElement.gridInstance.element), { ixs_tre: obj.ixs_tre, grid:gridElement.gridInstance.element, newRecord: false })
		this.close();
		}

		/** vytvo�it menubar */
		private createMenuBar() {

			const menuBar: MenuParams[] = [];

			this.actions.addRange({ 
			actNext: {
			        name: "actNext",
			        caption: "jres:33000001",  //RC 33000001 : Dal���
			        captionVisible: "never",
			        icon: "gi-arrow-down",
			        run: (ev, ctx) => {
			            this.nextAndPreviousAction(true);
			        }
			    },
			    actPrevious: {
			        name: "actPrevious",
			        caption: "jres:33000002", //RC 33000002 : P�edchoz�
			        captionVisible: "never",
			        icon: "gi-arrow-down gi-rot180",
			        run: (ev, ctx) => {
			            this.nextAndPreviousAction(false);
			        }
			    },
              actSaveRecord: {
                    visible: this.newRecord,
                    name: "actSaveRecord",
                    icon: "gi-save",
                    caption: "jres:32131041",			//RC 32131041 : Ulo�it
                    run: () => {
                        // kolekce dat
                        var form = this.findForms("FormStrediskoSpisovychUzluService");
                        if (form.gform("isValid")) {
                            var nova_data: Gordic.AdmIsl.Interface.GStrediskoSpisovychUzluSaveDto = {};       // vytvo��m pr�zdn� objekt spr�vn�ho typu
                            this.findFields().gfield("model", "collect", nova_data);    // na�tu do n�j data z formul��e
                            this.saveData(nova_data); // pokus�m se ulo�it data do DB
                        }
                    }
                },
                actEditRecord: {
                        visible: true,
                        name: "actEditRecord",
                        icon: "gi-pencil",
                        caption: "jres:32000120",			//RC 32000120 : Editace
                        run: () => {
                            this.SetEditMode(true);
                            this.SetMenuButtons(true);
                            //this.strediskaTab.updateStrediskaAction(true);
                        }
                },
                actCancelSaveRecord: {
                        visible: false,
                        name: "actCancelSaveRecord",
                        icon: "gi-window-close",
                        caption: "jres:32000122",			//RC 32000122 : Ukon�it editaci
                        run: () => {
                            this.refreshDetail();           // ob�erstv�m p�vodn� data z datab�ze
                            this.HideAllFlash();
                            this.SetEditMode(false);
                            this.SetMenuButtons(false);
                            //this.strediskaTab.updateStrediskaAction(false);
                        }
                },
                actRefresh: {
                        icon: "gi-refresh",
                        name: "actRefresh",
                        caption: "jres:32131040",			//RC 32131040 : Ob�erstven�
                        run: () => {
                        this.refreshDetail();
                        }
                },
			});

			this.menuBar([
			    { action: this.actions.actSaveRecord, favorite: true },
			    { action: this.actions.actEditRecord, favorite: true },
			    { action: this.actions.actCancelSaveRecord, favorite: true, visible: !this.newRecord },
			    { action: this.actions.actRefresh, favorite: true, visible: !this.editMode },
			    { action: this.actions.actPrevious, favorite: true, align: "opposite", visible: !this.newRecord },
			    { action: this.actions.actNext, favorite: true, align: "opposite", visible: !this.newRecord },
			])
            if (this.gridRemoteControl.current()) {
                this.actions.actPrevious?.enabled(this.gridRemoteControl.current().prevRow != null);
                this.actions.actNext?.enabled(this.gridRemoteControl.current().nextRow != null);
            } else {
                this.actions.actPrevious?.enabled(false);
                this.actions.actNext?.enabled(false);
            }

			//this.menuBar(menuBar);

        }


		/** vytvo�it commandbar */
		private createCommandBar() {

			const commandBar: MenuParams[] = [];

            // CLOSE
			commandBar.push({								
				favorite: true,
				action: this.actions.add(new GAction({
					name: "actZavrit",
					icon: "gi-window-close",
					caption: "jres:32131042",				//RC 32131042 : Zav��t
					run: () => {
						this.close();
					}
				}))
			});

			this.commandBar(commandBar);
		}

		//#endregion

		//#region statusbar

		/** odstranit v�echny vlastn� t��dy ze statusbaru */
		private removeAllCustomClassOnStatusBar() {
			var myclass = $(".statusbar-aktivita-class").find(".g-static__text");
			myclass.removeClass("statusbar-aktivita-class-green");
			myclass.removeClass("statusbar-aktivita-class-blue");
			myclass.removeClass("statusbar-aktivita-class-red");
		}

		//#endregion

		//#region sidebar

		/** vytvo�it panel */
		private createPanel(): GSideBarPanelOptions {

			this.panelId = "panelNahled";

			let panel = {
				minWidth: 300,
				id: this.panelId,
				caption: "jres:32131038",							//RC 32131038 : N�hled
                leaf: "jres:32131038",								//RC 32131038 : N�hled
                icon: "gi-nahled",
				open: (ev, obj) => {
					this.refreshPanel(ITypePanel.Neurceno, $(ev.target))
				},
			} as GSideBarPanelOptions;

			return panel;
		}

		/** odstranit sidebar */
		private removeSidebar() {
			if (this.sidebar !== undefined) {
				this.sidebar.gsidebar("removeAll");
			}
		}

		/** vytvo�it sidebar */
		private createSidebar() {

			this.removeSidebar();
			var myPanels: GSideBarBarOptions[] = [];

			var auditPristupu = new Gordic.Adm.WebControls.AdmAuditPristupu();
			var panelAudit = auditPristupu.create( this.sxsDetail || "", this.MetaData?.typ_obj || 0);
			myPanels.push(panelAudit);

			//var extIdentifikace = new Gordic.Adm.WebControls.AdmExtIdentifikace();
			//var panelExtIdentifikace = extIdentifikace.create( this.sxsDetail || "", this.MetaData?.typ_obj || 0);
			//myPanels.push(panelExtIdentifikace);

			//var poznamky = new Gordic.Adm.WebControls.AdmPoznamky();
			//var panelPoznamky = poznamky.create(this,  this.sxsDetail || "", this.MetaData?.typ_obj || 0);
			//myPanels.push(panelPoznamky);

			this.sidebar = $(this.element).gsidebar({
				userSettings: this.userSettings,
				right: {
					pinned: true,
					panels: myPanels
				}
			});
		}

		/** ob�erstven� panelu v sidebaru */
		private refreshPanel(type: ITypePanel, elementPanel?: JQuery<HTMLElement>): void {

			var panel: JQuery<HTMLElement> | undefined;

			if (this.sidebar !== undefined) {
				panel = this.sidebar.gsidebar("getPanel", this.panelId);
			}
			else {
				panel = elementPanel;
			}

			if (panel !== undefined) {

				if (this.panelElement !== undefined) {
					this.panelElement.remove();
				}

				this.panelElement = $("<div>").appendTo(panel);

				//if (type === ITypePanel.HistorieSpusteni) {
				//	GridUtils.setPanelGrid("jres:32000055", this.row_historie_spusteni, this.gridFormatHistorieSpusteni, this.panelElement);
				//}
				//else {
					this.setPreviewEmpty();
				//}

			}

		}
        /** vytov�en� pr�zdn�ho sidebar panelu s n�hledek */
		private setPreviewEmpty(): void {
			var p7s_element = $("<div'>").addClass("Adm-p7s-class");
			p7s_element.appendTo(this.panelElement);
			p7s_element.text("jres:32131043"); //RC 32131043 : N�hled nen� k dispozici.
		}

		//#endregion


	}
}
